$(document).on('click', 'form#multiple_dispensaries_confirmation button[type=submit]', function (event) {
  $('#multiple_dispensaries_confirmation_modal').modal('hide');
});